import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { ErrorService } from './error.service';
import { TermsAndConditions, TermsFunc } from './webapiclient.service';

@Injectable({
  providedIn: 'root'
})
export class TermsService {

  constructor(
    private termsFunc: TermsFunc,
    private errorService: ErrorService

  ) { }


  async getAll() {
    let model: TermsAndConditions[] = {} as TermsAndConditions[];
    return new Promise((resolve, reject) => {
        this.termsFunc.getAll().pipe(first()).subscribe({
          next: (v) => model = v,
          error: (e) => reject(e.message),
          complete: () => resolve(model)
        })
    });
  }

  async getActualTerms() {
    let model: TermsAndConditions = {} as TermsAndConditions;
    return new Promise((resolve, reject) => {
        this.termsFunc.getActualTerms().pipe(first()).subscribe({
          next: (v) => model = v,
          error: (e) => reject(e.message),
          complete: () => resolve(model)
        })
    });
  }

  async insert(values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
        this.termsFunc.insert(values).pipe(first()).subscribe({
          next: (v) => result = v,
          error: (e) => reject(e),
          complete: () => {
            if (result.body === "OK") {
              resolve("OK");
            } else {
              reject(result.body);
            }
          }
        })
    });
    }


}
